import { render, staticRenderFns } from "./PlatformLoadout.vue?vue&type=template&id=5c77bebc&"
import script from "./PlatformLoadout.vue?vue&type=script&lang=js&"
export * from "./PlatformLoadout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports